import React, { Fragment, useEffect, useState } from "react";
import flatten from "lodash/flatten";
import chunk from "lodash/chunk";
import { Link } from "@quintype/components";
import { getLatestStories } from "../../../../../api/utils";
import { PublishAndReadTime } from "../../../atoms/PublishAndReadTime";
import { replaceWithAlternates } from "../../../utils";
import { getStoryLabel } from "../../../utils/story";
import { Label } from "../../../atoms/Label";
import Headline from "../../../atoms/Headline";

import "./latest-stories.m.css";

export default function LatestStories() {
  const [latestStories, setLatestStories] = useState([]);
  const [collectionTitle, setCollectionTitle] = useState("Latest Stories");

  useEffect(() => {
    getLatestStories().then((response) => {
      setLatestStories(response?.items);
      setCollectionTitle(response?.name);
    });
  }, []);

  return (
    latestStories?.length > 0 && (
      <div styleName="latest-stories-wrapper">
        <p styleName="title">{collectionTitle}</p>

        <div styleName="wrapper">
          {flatten(
            chunk(latestStories, 2).map((storyGroup, index) => (
              <Fragment key={index}>
                <div styleName="story-row">
                  {storyGroup.map((groupItem, index) => {
                    const { story } = groupItem;
                    const label = getStoryLabel(story);
                    const alternateStory = replaceWithAlternates(story);
                    return (
                      <Fragment key={index}>
                        <Link href={`/${story?.slug}`}>
                          <div styleName="card-details">
                            {label && <Label story={story} />}
                            {alternateStory?.headline && (
                              <Headline headline={alternateStory?.headline} styleName="headline" />
                            )}
                            <PublishAndReadTime story={story} showReadTime={true} showTimestamp={true} />
                          </div>
                        </Link>
                        {index !== storyGroup.length - 1 && <div styleName="divider"></div>}
                      </Fragment>
                    );
                  })}
                </div>
                <div styleName="row-divider"></div>
              </Fragment>
            ))
          )}
        </div>
      </div>
    )
  );
}
